export default "__VITE_ASSET__Bt65lr$6__"